module.exports = __webpack_public_path__ + "img/banner.65cc03d3.png";